<div class="onboarding-page-container">
  <div class="result-table">
    <div class="action-bar">
      <div class="total-container">
        <span class="total">Policy Count: {{ rows.length }} </span>
        @if (authorization.authorizedAdminAgent) {
          <span class="total"
            >Selected Items: {{ selectedRows.length }}
          </span>
        }
      </div>

      @if (authorization.authorizedAdminAgent) {
        <div class="assign-options-container">
          <label class="toggle-label">
            <span>Only Unassigned</span>
            <p-toggleswitch
              [ngModel]="isDisplayingOnlyUnassigned"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="filterUnassignedOnly()"
            />
          </label>
          <p-select
            id="agents-select"
            [options]="agents | orderBy: 'displayName' : 'asc'"
            optionLabel="displayName"
            placeholder="Agents"
            [(ngModel)]="agentsSelected"
            [ngModelOptions]="{ standalone: true }"
            appendTo="body"
          />
          <p-button label="Assign" (onClick)="setAgentsSelected()" />
        </div>
      }
      <p-button label="No Match" (onClick)="openDialog()" />
      @if (authorization.authorizedAdminIT) {
        <p-button
          label="Download NB Pack"
          (onClick)="openDownloadNBPackDialog()"
        />
      }
      <div>
        <form [formGroup]="onboardingForm" id="search-by-policy-code">
          <p-iconfield iconPosition="right">
            <input
              pInputText
              (focusout)="searchByPolicyCode()"
              placeholder="Search by policy code"
              formControlName="policyCode"
            />
            <p-inputicon>
              <span class="material-icons">search</span>
            </p-inputicon>
          </p-iconfield>
        </form>
      </div>
    </div>

    <p-table
      [value]="rows"
      [(selection)]="selectedRows"
      dataKey="policyCode"
      sortMode="single"
    >
      <ng-template pTemplate="header">
        <tr>
          <th
            class="select-column"
            [style.display]="isAssignModeOn ? 'revert' : 'none'"
          >
            <p-tableHeaderCheckbox />
          </th>
          <th pSortableColumn="policyCode">
            Policy Code <p-sortIcon field="policyCode" />
          </th>
          <th pSortableColumn="diaryTotal" style="text-align: center">
            Total <p-sortIcon field="diaryTotal" />
          </th>
          <th pSortableColumn="dateUploaded">
            Date Received (oldest) <p-sortIcon field="dateUploaded" />
          </th>
          <th style="text-align: center">Time Received</th>
          <th>
            <span class="material-icons" style="padding-left: 12px"
              >file_present</span
            >
          </th>
          <th pSortableColumn="agentName">
            Agent Assigned <p-sortIcon field="agentName" />
          </th>
          <th pSortableColumn="dateAssigned">
            Date Assigned <p-sortIcon field="dateAssigned" />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td
            class="select-column"
            [style.display]="isAssignModeOn ? 'revert' : 'none'"
          >
            <p-tableCheckbox
              [value]="row"
              (click)="$event.stopPropagation()"
            />
          </td>
          <td>{{ row.policyCode }}</td>
          <td style="text-align: center">{{ row.diaryTotal }}</td>
          <td>{{ row.dateUploaded | date: "dd/MM/yyyy" }}</td>
          <td style="text-align: center">{{ row.dateUploaded | date: "h:mm a" }}</td>
          <td>
            <button
              type="button"
              class="icon-button"
              (click)="
                getPolicyDetails(row.policyCode, row.agentEmail, row.dateAssigned)
              "
            >
              <span
                class="material-icons"
                aria-hidden="false"
                aria-label="Open policy documents"
                >file_present</span
              >
            </button>
          </td>
          <td>{{ row.agentName }}</td>
          <td>{{ row.dateAssigned | date: "dd/MM/yyyy - h:mm a" }}</td>
        </tr>
      </ng-template>
    </p-table>

    @if (!isLoadingResults && rows.length == 0) {
      <div class="no-records-found-container">
        <span>No record found</span>
      </div>
    }
    @if (isLoadingResults) {
      <div class="table-spinner-container">
        <p-progressspinner ariaLabel="loading" />
      </div>
    }
  </div>
</div>
